import React, { useEffect } from 'react';
import {
  Wrapper,
  MixedLink,
  SocialLink,
} from '../common';
import { InteractivePita } from '../navigation';
import { TABLET_BREAKPOINT } from '../../util/breakpoints';
import { toKebabCase } from '../../util/helpers';
import './NavigationMenu.scss';

const ESC_KEY_CODE = 'Escape';

const NavigationMenu = (props) => {
  const {
    navOpen,
    navIsAnimating,
    // location,
    settings,
    closeNav,
    viewportWidth,
  } = props;
  const {
    primaryMenu,
    socialLinks,
    supportingPages,
  } = settings;
  const isTablet = Boolean(viewportWidth <= TABLET_BREAKPOINT);
  const keyPressHandler = ({ key }) => {
    // Set drawing to false if user presses the 'escape' key
    if (key === ESC_KEY_CODE && navOpen) {
      closeNav();
    }
  };
  useEffect(() => {
    window.addEventListener('keydown', keyPressHandler);
    return () => {
      window.removeEventListener('keydown', keyPressHandler);
    };
  }, [navOpen]);
  const classes = `${navOpen ? ' active' : ''}${navIsAnimating ? ' is-animating' : ''}`;
  return (
    <div className={`navigation-menu${classes}`}>
      <Wrapper isBound>
        <div className="cols">
          <div className="col col-left col-links">
            <div className="container">
              <div className="primary-links">
                { primaryMenu && primaryMenu.length > 0 && (
                  <ul className="links">
                    {primaryMenu.map(link => (
                      <li className="link" key={toKebabCase(link.title.text)}>
                        <MixedLink
                          buttonLabel={link.title}
                          buttonLink={link.pageLink}
                          onClick={closeNav}
                        />
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="secondary-links">
                { socialLinks && socialLinks.length > 0 && (
                  <ul className="social-links">
                    {socialLinks.map(item => (
                      <li className="link" key={item.type}>
                        <SocialLink socialLink={item} />
                      </li>
                    ))}
                  </ul>
                )}
                { supportingPages && supportingPages.length > 0 && (
                  <ul className="supporting-pages">
                    {supportingPages.map(link => (
                      <li className="link" key={toKebabCase(link.title.text)}>
                        <MixedLink
                          buttonLabel={link.title}
                          buttonLink={link.pageLink}
                          onClick={closeNav}
                        />
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
          {!isTablet && (
            <div className="col col-right col-pita">
              <InteractivePita />
            </div>
          )}
        </div>
      </Wrapper>
    </div>
  );
};


export default NavigationMenu;
